// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ypwd","content":"styles_content__px9Oq"};